// eslint-disable-next-line @stencil-community/ban-exported-const-enums
export enum StatusType {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error'
}
